module.exports = __webpack_public_path__ + "static/starblanket-90cb59c23e923c5a5695d096367e3df7.jpeg";